
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-menu-toggle], [data-search-toggle]');
  if (!button) return;
  const header = button.closest('[data-lm-header]');
  const panel = document.getElementById(button.getAttribute('aria-controls'));
  if (!header || !panel) return;
  const opening = button.getAttribute('aria-expanded') !== 'true';
  header.querySelectorAll('[data-menu-toggle], [data-search-toggle]').forEach((other) => {
    const otherPanel = document.getElementById(other.getAttribute('aria-controls'));
    other.setAttribute('aria-expanded', 'false');
    otherPanel?.classList.add('hidden');
  });
  button.setAttribute('aria-expanded', String(opening));
  panel.classList.toggle('hidden', !opening);
  if (opening && button.hasAttribute('data-search-toggle')) panel.querySelector('[name="q"]')?.focus();
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-lm-header] [aria-expanded="true"]').forEach((button) => {
    document.getElementById(button.getAttribute('aria-controls'))?.classList.add('hidden');
    button.setAttribute('aria-expanded', 'false');
    button.focus();
  });
});
let cartRequest = 0;
async function refreshCart() {
  const request = ++cartRequest;
  try {
    const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    if (request !== cartRequest) return;
    document.querySelectorAll('[data-lm-cart-count]').forEach((element) => { element.textContent = cart.item_count; });
  } catch {}
}
import('@shopify/events').then(({ StandardEvents }) => {
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if (event.promise) event.promise.then(refreshCart).catch(() => {});
    else refreshCart();
  });
}).catch(() => {});
window.addEventListener('pageshow', refreshCart);
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('[data-lm-header]')) refreshCart();
});
